import { createContext } from 'react';

import { AmplitudeFlagType } from './amplitudeFlags';

export interface AmplitudeExperimentContextValue {
  isVariantActive: (variantId: AmplitudeFlagType, truthyExperimentValue: string) => boolean;
  getPayloadVariant: <T>(variantId: AmplitudeFlagType) => T | null;
  getVariantValue: (variantId: AmplitudeFlagType) => string | null;
}

export const AmplitudeExperimentContext = createContext<AmplitudeExperimentContextValue | null>(null);
